<div class="dialog-container">
  <mat-card class="no-shadow">
    <mat-card-header class="title">
      <mat-card-title class="no-subtitle">Pinned Flights</mat-card-title>
      <button mat-icon-button color="primary" (click)="onCloseDialog()" tabindex="-1">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <ul>
        <li>The purpose of pinned flights is to provide a quick reference to flights of interest that aren't part
          of your schedule. Most likely these will be commute or unscheduled deadhead flights.
        </li>

        <li><span class="caution-color font-medium">
            Pinned flights aren't currently synced between devices (pinned flights on
            your phone won't automatically show up on your iPad).</span></li>
        <li>
          Selecting a pinned flight will navigate to its flight details screen. To resume viewing sequence
          and flight information from your schedule, return to the calendar and navigate as usual.
        </li>
        <li>Select the trash can icon to remove a pinned flight.</li>
        <li>Pinned flights are automatically removed two days after scheduled departure.</li>
      </ul>

    </mat-card-content>
  </mat-card>
</div>